module.exports = __webpack_public_path__ + "static/media/ic_pdf.554e78c8.svg";